import { render, staticRenderFns } from "./Collage.vue?vue&type=template&id=53ba2bce&scoped=true&"
import script from "./Collage.vue?vue&type=script&lang=js&"
export * from "./Collage.vue?vue&type=script&lang=js&"
import style0 from "./Collage.vue?vue&type=style&index=0&id=53ba2bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba2bce",
  null
  
)

export default component.exports